"use strict";
// src/graphql/client.ts
Object.defineProperty(exports, "__esModule", { value: true });
/* This file will contain the setup for the Apollo Client:
 */
const core_1 = require("@apollo/client/core");
const client = new core_1.ApolloClient({
    link: new core_1.HttpLink({
        uri: "https://sui-mainnet.mystenlabs.com/graphql",
    }),
    cache: new core_1.InMemoryCache(),
});
exports.default = client;
//# sourceMappingURL=client.js.map